import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Button, Image, Link} from '@udemy/react-core-components';
import {PERSONALIZE_URL} from '@udemy/react-personalized-content';
import {useUDData, useUDLink} from '@udemy/ud-data';

import {UserOccupationInfo} from 'src/lib/fetchers';

import styles from './set-career-goal-unit.module.less';

interface SetCareerGoalUnitComponentProps {
    enableInProductOccupationCollection: boolean;
    userOccupationInfo?: UserOccupationInfo;
    className?: string;
}

export const SetCareerGoalUnitComponent: React.FC<SetCareerGoalUnitComponentProps> = ({
    enableInProductOccupationCollection,
    userOccupationInfo,
    className = 'component-margin',
}) => {
    const {gettext} = useI18n();
    const {Config} = useUDData();
    const udLink = useUDLink();

    // Mirror the monolith: only show when the user has NO occupation data at all (!occupationData).
    // If the user has any occupation data (raw/group/canonical), hide this unit.
    if (
        enableInProductOccupationCollection ||
        userOccupationInfo?.raw ||
        userOccupationInfo?.group ||
        userOccupationInfo?.canonical
    ) {
        return null;
    }

    const imgSource = udLink.toStorageStaticAsset(
        'consumer-subscription/occupation/subscription_vertical_spot.png',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        {Config},
    );

    return (
        <div className={className} data-purpose="set-career-goal-unit-container">
            <h2 className={classNames('ud-heading-serif-xl', styles.header)} data-purpose="header">
                {gettext('Add your occupation and interests')}
            </h2>
            <p className={styles.subtitle} data-purpose="subtitle">
                {gettext('Get personalized recommendations based on your goals and interests.')}
            </p>
            <section className={styles.container}>
                <Image alt="" width={206} height={143} src={imgSource} data-purpose="image" />
                <Button
                    data-purpose="occupation-link"
                    className="ud-link-underline"
                    componentClass={Link}
                    size="xsmall"
                    to={PERSONALIZE_URL}
                    udStyle="ghost"
                >
                    {gettext('Add occupation and interests')}
                </Button>
            </section>
        </div>
    );
};
